export enum DocumentTemplate {
	'DEPARTMENT'= 'DOC_TEMPLATE-DEPARTMENT',
	'EFFECTIVE_DATE'= 'DOC_TEMPLATE-EFFECTIVE_DATE',
	'PROFILE_NAME'= 'DOC_TEMPLATE-PROFILE_NAME',
	'PROFILE_DESCRIPTION'= 'DOC_TEMPLATE-PROFILE_DESCRIPTION',
	'OFFICE'= 'DOC_TEMPLATE-OFFICE',
	'PROFILE_CHANGE_STATUS'= 'DOC_TEMPLATE-PROFILE_CHANGE_STATUS',
	'REC_STATUS'= 'DOC_TEMPLATE-REC_STATUS',
	'FILE_PATH'= 'DOC_TEMPLATE-FILE_PATH',
	'FILENAME'= 'DOC_TEMPLATE_FILES-FILENAME',
	'PAYMENT_TYPE'= 'DOC_TEMPLATE_FILES-PAYMENT_TYPE',
  'PAYMENT_CATEGORY'= 'DOC_TEMPLATE_FILES-PAYMENT_CATEGORY',
	'REGULATION'= 'DOC_TEMPLATE_FILES-REGULATION'
};
